module.exports = __webpack_public_path__ + "img/1499032258.56a31779.jpg";